/* FÉNIX R07.96 — cart synchronization guard.
   The base drawer remains the only add/change/remove authority.
   This guard does not monkey-patch fetch/XHR; it only refreshes after the base add lock has released. */
(function(){
  'use strict';

  var refreshTimer=0;

  function refreshAfterConfirmedAdd(){
    if(refreshTimer) window.clearTimeout(refreshTimer);
    if(window.nmCartDrawer&&typeof window.nmCartDrawer.open==='function'){
      try{window.nmCartDrawer.open();}catch(e){}
    }
    refreshTimer=window.setTimeout(function(){
      refreshTimer=0;
      if(window.nmCartDrawer&&typeof window.nmCartDrawer.refresh==='function'){
        try{window.nmCartDrawer.refresh();}catch(e){}
      }
    },140);
  }

  document.addEventListener('nm:cart:added',refreshAfterConfirmedAdd,true);

  document.addEventListener('click',function(event){
    var trigger=event.target&&event.target.closest&&event.target.closest('[data-nm-cart-trigger]');
    if(trigger) event.preventDefault();
  },true);
})();
